import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    name: Yup.string().required("Name is required"),
    cost: Yup.number("Please enter a valid cost").required("Cost is required"),
});